export default {
  VIOLET: 'VIOLET',
  ORANGE: 'ORANGE',
  GREEN: 'GREEN',
  RED: 'RED',
}
